export default "<div *ngIf=\"errorMessage !== null\">{{errorMessage}}</div>\r\n"